<nwm-menu />
<!-- <SubMenu [items]="subMenuItems"></SubMenu> -->

<div class="content">
  <!-- Quarterly Portfolio Review-->
  <div class="main pb-4 mt-4">
    <a class="anchor" id="newsletters" aria-hidden="true"></a>
    <nwm-resource-newsletter />
  </div>

  <!-- Fund Information -->
  <div class="main pb-4">
    <a class="anchor" id="plannings" aria-hidden="true"></a>
    <nwm-resource-planning />
    <!-- NWM Investment Pricing & Update Schedule -->
    <a class="anchor" id="pricing" aria-hidden="true"></a>
    <nwm-resource-pricing />
  </div>

  <div class="main pb-4">
    <a class="anchor" id="thinking" aria-hidden="true"></a>
    <div class="row no-gutters">
      <div class="col-xxl-10 offset-xxl-1" style="border-top: 2px solid #D1D7DC">
        <h1 class="mt-4 mb-2">
          Our Thinking
        </h1>
        <p>From economic updates and financial strategies, to interesting stories and features, keep up-to-date on Nicola Wealth’s thinking through our Monthly Market Commentary, Compass Newsletter, and Wealth Exchange Podcast.</p>
        <a target="_blank" href="https://www.nicolawealth.com/insights">LEARN MORE</a>
      </div>
    </div>
  </div>

  <div class="main pb-4">
    <a class="anchor" id="events" aria-hidden="true"></a>
    <div class="row no-gutters">
      <div class="col-xxl-10 offset-xxl-1">
        <h1 class="mt-4 mb-2">
          News & Events
        </h1>
        <p>Whether it’s the Financial Post, Globe and Mail, or Wall Street Journal, Nicola Wealth is frequently featured in the media, offering insight on any number of investment and financial planning topics affecting affluent families today.  Also check this page to keep informed about Nicola Wealth’s upcoming events and presentations.</p>
        <a target="_blank" href="https://www.nicolawealth.com/insights/collection/nicola-in-the-news">LEARN MORE</a>
      </div>
    </div>
  </div>

  <div class="main pb-4">
    <a class="anchor" id="giving" aria-hidden="true"></a>
    <div class="row no-gutters">
      <div class="col-xxl-10 offset-xxl-1 pb-5">
        <h1 class="mt-4 mb-2">
          Giving
        </h1>
        <p>We recognize that many of our clients have a desire to give back and, in some cases, build a lasting charitable legacy. Nicola Wealth has a strong culture of giving back and we are committed to helping our clients enhance their gift-giving potential while providing them with a great tax planning tool.  The Nicola Wealth Private Giving Foundation (PGF) was established to access the advantages that a foundation offers, but on a more cost-effective basis (Nicola Wealth covers the administrative costs and fees for all PGF donor-advised funds).</p>
        <a target="_blank" href="https://www.nicolawealth.com/private-giving-foundation">LEARN MORE</a>
      </div>
    </div>
  </div>
</div>

